import { styled, Theme, Box, ListItem } from '@mui/material';
import { LEFT_SIDE_MENU_WIDTH } from '../../consts/theme.conts';

export const StyledSidebar = styled(Box)(({ theme }: {theme: Theme}) => ({
  position: 'fixed',
  left: 0,
  top: 0,
  height: '100vh',
  backgroundColor: '#1D3461',
  boxShadow: theme.shadows[3],
  width: LEFT_SIDE_MENU_WIDTH,
  zIndex: 1200,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'visible', // Allow menu items to expand outside
}));

export const StyledListItem = styled(ListItem)<{ disabled?: boolean }>(({ theme, disabled }) => ({
  justifyContent: 'center',
  padding: '12px',
  position: 'relative',
  transition: 'background-color 0.2s ease',
  cursor: disabled ? 'default' : 'pointer',
  '&:hover': {
    backgroundColor: disabled ? 'transparent' : '#16448f',
    '& .menu-text': {
      opacity: disabled ? 0 : 1,
      visibility: disabled ? 'hidden' : 'visible',
      transform: disabled ? 'translateX(-20px)' : 'translateX(0)',
    },
    '& .MuiListItemIcon-root': {
      color: disabled ? 'rgba(255, 255, 255, 0.5)' : theme.palette.primary.main,
    },
  },
}));

export const MenuText = styled(Box)(({ theme }: {theme: Theme}) => ({
  position: 'absolute',
  left: '63px',
  gap: '10px',
  display: 'flex',
  alignItems: 'center',
  height: '34px',
  backgroundColor: '#16448f',
  color: theme.palette.common.white,
  padding: '8px 16px',
  borderRadius: '0 4px 4px 0',
  whiteSpace: 'nowrap',
  zIndex: 1,
  opacity: 0,
  visibility: 'hidden',
  transform: 'translateX(-20px)',
  transition: 'all 0.3s ease'
}));